<template lang="html">
  <button
    v-if="prices[funding]"
    class="flex items-center mr-auto my-3 md:mt-0 md:mr-0"
  >
    <div
      @click="toggle"
      class="flex items-center flex-nowrap cursor-pointer gap-3"
    >
      <input v-bind="checked" type="checkbox" :checked="checked" />
      <div class="check check--big">
        <IconCheck />
      </div>
      <div
        class="text-left font-light text-grey-900 dark:text-gold-50 flex flex-wrap gap-1.5"
      >
        <span>{{ title }}</span>

        <span
          v-if="prevPrice"
          class="text-center border-gold-500 bg-gold-500 text-white rounded-xl px-3 text-sm border inline-block mx-auto md:mx-0"
        >
          Medlemspris
          {{
            prices.buy && funding == 'buy'
              ? this.$filters.formatNumber(prices.clubman_buy)
              : this.$filters.formatNumber(prices['clubman_' + funding])
          }}
          ,-</span
        >

        <span v-if="prices.buy && funding == 'buy'" :class="prevPriceClass">
          (+{{ prevPrice || this.$filters.formatNumber(prices.buy) }} NOK)
        </span>

        <span
          v-else-if="funding == 'leasing' || funding == 'subscription'"
          :class="prevPriceClass"
        >
          (+{{ prevPrice || this.$filters.formatNumber(prices[funding]) }} NOK
          per mnd)
        </span>
      </div>
      <div v-if="description">
        <button class="checkbox-info">i</button>
        <div class="checkbox-description" v-html="description"></div>
      </div>
    </div>
  </button>
</template>

<script>
import IconCheck from './IconCheck.vue';

export default {
  name: 'LabbeledCheckbox',
  props: [
    'title',
    'description',
    'prices',
    'funding',
    'singleChoice',
    'activeOptions',
    'prevPrice',
  ],
  emits: ['toggleOption'],
  components: {
    IconCheck,
  },
  data() {
    return {
      checked: this.activeOptions.some((filter) => filter.title === this.title),
    };
  },
  computed: {
    prevPriceClass() {
      return this.prevPrice ? 'text-xs line-through' : '';
    },
  },
  methods: {
    toggle() {
      this.checked = !this.checked;
      this.emitChange();
    },
    emitChange() {
      this.$emit('toggleOption', {
        singleChoice: this.singleChoice,
        title: this.title,
        checked: this.checked,
        buy: parseInt(this.prices.buy),
        leasing: parseInt(this.prices.leasing),
        subscription: parseInt(this.prices.subscription),
        clubman_buy: parseInt(this.prices.clubman_buy),
        clubman_leasing: parseInt(this.prices.clubman_leasing),
        clubman_subscription: parseInt(this.prices.clubman_subscription),
      });
    },
  },
  watch: {
    funding() {
      this.emitChange();
    },
    activeOptions(next) {
      this.checked = next.some((filter) => filter.title === this.title);
    },
  },
};
</script>
